export class Etiqueta {
  id = null;
  ativado = null;
  descricao = null;
  larguraFolha = null;
  alturaEtiqueta = null;
  margemBordaEtiqueta = null;
  margemMeioEtiqueta = null;
  colunasEtiqueta = null;
  layout = [];

  constructor(etiqueta, id) {
    if (id) {
      this.id = id;
    }
    this.ativado = etiqueta.ativado;
    this.descricao = etiqueta.descricao;
    this.larguraFolha = etiqueta.larguraFolha;
    this.alturaEtiqueta = etiqueta.alturaEtiqueta;
    this.margemBordaEtiqueta = etiqueta.margemBordaEtiqueta || 1;
    this.margemMeioEtiqueta = etiqueta.margemMeioEtiqueta;
    this.colunasEtiqueta = etiqueta.colunasEtiqueta;
    this.layout = etiqueta.layout;
  }

  createLayout(labelElements) {
    if (!labelElements?.length) return;
    this.layout = labelElements.map((l) => new Layout(l));
  }
}

class Layout {
  elemento = null;
  x = null;
  y = null;
  fontSize = null;
  codeType = null;
  codeHeight = null;
  codeWidth = null;
  showLabelCode = null;

  constructor(layout) {
    this.elemento = layout.elemento;
    this.x = layout.x;
    this.y = layout.y;
    this.fontSize = layout.fontSize;
    this.codeType = layout.codeType || null;
    this.codeHeight = layout.codeHeight ? parseFloat(layout.codeHeight) : null;
    this.codeWidth = layout.codeWidth ? parseFloat(layout.codeWidth) : null;
    this.showLabelCode = layout.showLabelCode;
  }
}
